/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import axios from "axios";
import { Auth } from "aws-amplify";
import { v2, errorToObject } from "@prftesp/cle-logger";
import { APIGateways } from "../../../utility/APIGateways";
import errorCodes from "../../../utility/errorCodes";

const COMPONENT_NAME = "adminCCPServices/externalContactsService";

/**
 * Gets all external contacts
 */
export const getExternalContacts = async () => {
	try {
		const token = (await Auth.currentSession()).getIdToken().getJwtToken();
		const response = await axios.get(`${APIGateways.externalContactsEndpoint}`, {
			headers: {
				Authorization: token,
			},
		});
		return response.data.result;
	} catch (error) {
		v2.error("Error while getting external contacts", {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.GET_TEAMS_USER_STATUSES_API_ERROR,
		});

		throw error;
	}
};

/**
 * Starts a teams conversation with an external contact
 */
export const startTeamsConversation = async (azureId, displayName, agentUsername) => {
	try {
		const token = (await Auth.currentSession()).getIdToken().getJwtToken();
		const response = await axios.post(
			`${APIGateways.startTeamsConversationEndpoint}`,
			{
				azureId,
				displayName,
				agentUsername,
			},
			{
				headers: {
					Authorization: token,
				},
			},
		);
		return response.data.result;
	} catch (error) {
		v2.error("Error while starting teams conversation", {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.START_TEAMS_CONVERSATION_ERROR,
		});

		throw error;
	}
};

/**
 * Gets teams conversation statuses
 */
export const getTeamsConversationStatus = async (azureUserIds) => {
	try {
		const token = (await Auth.currentSession()).getIdToken().getJwtToken();
		const response = await axios.post(
			`${APIGateways.getTeamsConversationStatusEndpoint}`,
			{
				azureUserIds,
			},
			{
				headers: {
					Authorization: token,
				},
			},
		);
		return response.data;
	} catch (error) {
		v2.error("Error while getting teams conversation statuses", {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.GET_TEAMS_CONVERSATION_STATUS_ERROR,
		});

		throw error;
	}
};
